module.exports = __webpack_public_path__ + "img/back_300.88ff509c.jpg";